// Packages
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { A11y, Autoplay, Navigation, Pagination } from "swiper";
import { SwiperSlide, Swiper } from "swiper/react";
import toast from "react-hot-toast";
// Components
import LandingSliderCard from "../../Common/Card/LandingSliderCard/LandingSliderCard";
import Slider from "../../Common/Slider/Slider";
// Styles
import Styles from "./Styles/LandingContent.module.css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// API
import {
  getArticles,
  getBooks,
  getEldersWords,
} from "../../../Services/getData";
// Images
import enamadImg from "../../../Assets/Icons/enamad-1star.png";
import parvaneNashrImg from "../../../Assets/Icons/parvane-nashre-digital.jpg";
import mojavezImg from "../../../Assets/Images/mojavez-parvane-nashr.jpg";
import quoteDownIcon from "../../../Assets/SVG/quote-down.svg";
import quetsBackground from "../../../Assets/Images/quets-background.png";
import actorIcon from "../../../Assets/Icons/actor.png";
import bloggerIcon from "../../../Assets/Icons/blogger.png";
import designerIcon from "../../../Assets/Icons/designer.png";
import noteIcon from "../../../Assets/Icons/note.png";
import philosophyIcon from "../../../Assets/Icons/philosophy.png";
import readIcon from "../../../Assets/Icons/read.png";
import researcherIcon from "../../../Assets/Icons/researcher.png";
import singerIcon from "../../../Assets/Icons/Singer.png";
import sourceIcon from "../../../Assets/Icons/source.png";
import writingIcon from "../../../Assets/Icons/writing.png";
import quotesIcon from "../../../Assets/Icons/Quotes.png";
import directorIcon from "../../../Assets/Icons/Director.png";
import bookIcon from "../../../Assets/Icons/bookForSelection.png";
import samandehi from "../../../Assets/Icons/samandehi.png";
import videoIcon from "../../../Assets/Icons/ویدیوها.png";
import hormeNamaIcon from "../../../Assets/Icons/هرمه نما.png";
import nashriatIcon from "../../../Assets/Icons/نشریات.png";
import aboutHormeIcon from "../../../Assets/Icons/درباره هرمه.png";
import articlesIcon from "../../../Assets/Icons/ایکون مقالات.png";
import podcastIcon from "../../../Assets/Icons/پادکست ها.png";
import contactHormeIcon from "../../../Assets/Icons/ارتباط با هرمه.png";

const LandingContent = () => {
  const [showMojavez, setShowMojavez] = useState(false);
  const [textuals, setTextuals] = useState([]);
  const [visuals, setVisuals] = useState([]);
  const [books, setBooks] = useState([]);
  const [eldersWords, setEldersWords] = useState([]);
  const reservedImages = [
    { name: "actor", icon: actorIcon },
    { name: "blogger", icon: bloggerIcon },
    { name: "designer", icon: designerIcon },
    { name: "note", icon: noteIcon },
    { name: "philosophy", icon: philosophyIcon },
    { name: "read", icon: readIcon },
    { name: "researcher", icon: researcherIcon },
    { name: "singer", icon: singerIcon },
    { name: "source", icon: sourceIcon },
    { name: "writing", icon: writingIcon },
    { name: "quotes", icon: quotesIcon },
    { name: "director", icon: directorIcon },
    { name: "book", icon: bookIcon },
  ];

  const reservedIcons = [
    { name: "video", icon: videoIcon },
    { name: "hormeNama", icon: hormeNamaIcon },
    { name: "nashriat", icon: nashriatIcon },
    { name: "aboutHorme", icon: aboutHormeIcon },
    { name: "article", icon: articlesIcon },
    { name: "podcast", icon: podcastIcon },
    { name: "contact", icon: contactHormeIcon },
  ];

  useEffect(() => {
    const api = async () => {
      try {
        const { data } = await getEldersWords();
        setEldersWords(data.words);
      } catch (ex) {
        console.log(ex.response.data.message);
      }
    };
    api();
  }, []);

  useEffect(() => {
    const api = async () => {
      try {
        const { data } = await getArticles("textual");
        setTextuals(data.article.slice(-8));
      } catch (ex) {
        // toast.error(ex.response.data.message);
      }
      try {
        const { data } = await getArticles("visual");
        setVisuals(data.article.slice(-8));
      } catch (ex) {
        // toast.error(ex.response.data.message);
      }
      try {
        const { data } = await getBooks();
        setBooks(data.books.slice(-8));
      } catch (ex) {
        // toast.error(ex.response.data.message);
      }
    };
    api();
  }, []);

  const handleChangePosts = (post) => {
    if (post.kind === "textual") {
      const copyTextuals = [...textuals];
      const filteredTextuals = copyTextuals.filter(
        (i) => i.category === post.category
      );
      setTextuals(filteredTextuals);
      toast.success(`لیست مقالات متنی بر اساس ${post.category} بروزرسانی شد`);
      return;
    } else if (post.kind === "visual") {
      const copyVisuals = [...visuals];
      const filteredVisuals = copyVisuals.filter(
        (i) => i.category === post.category
      );
      setVisuals(filteredVisuals);
      toast.success(`لیست مقالات تصویری بر اساس ${post.category} بروزرسانی شد`);
      return;
    } else {
      const copyBooks = [...books];
      const filteredBooks = copyBooks.filter(
        (i) => i.category === post.category
      );
      setBooks(filteredBooks);
      toast.success(`لیست کتابها بر اساس ${post.category} بروزرسانی شد`);
      return;
    }
  };

  return (
    <div className={Styles.posts}>
      <Lightbox
        open={showMojavez}
        close={() => setShowMojavez(false)}
        slides={[{ src: mojavezImg }]}
      />
      <div className={Styles.slider}>
        <motion.div
          initial={{ y: 800 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.8 }}
          className={Styles.singleSlider}
        >
          <Slider
            itemsPerView={1}
            slidesClass="landingSlideContainer"
            Card={LandingSliderCard}
            data={books}
            error="کتابی یافت نشد"
            kind="book"
            handleChangePosts={handleChangePosts}
            landing={true}
            reservedIcons={reservedIcons}
          />
        </motion.div>
        <motion.div
          initial={{ y: 800 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className={Styles.singleSlider}
          style={{ marginLeft: "50px" }}
        >
          <Slider
            itemsPerView={1}
            slidesClass="landingSlideContainer"
            Card={LandingSliderCard}
            data={visuals}
            error="مقاله ای یافت نشد"
            kind="visual"
            handleChangePosts={handleChangePosts}
            landing={true}
            reservedIcons={reservedIcons}
          />
        </motion.div>
        <motion.div
          initial={{ y: 800 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className={Styles.singleSlider}
          style={{ marginLeft: "50px" }}
        >
          <Slider
            itemsPerView={1}
            slidesClass="landingSlideContainer"
            Card={LandingSliderCard}
            data={textuals}
            error="مقاله ای یافت نشد"
            kind="article"
            handleChangePosts={handleChangePosts}
            landing={true}
            reservedIcons={reservedIcons}
          />
        </motion.div>
      </div>
      <motion.div
        initial={{ y: 500 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, delay: 0.6 }}
        className={Styles.footer}
      >
        {/* <div className={Styles.left}></div> */}
        <div
          className={Styles.right}
          style={window.innerWidth > 450 ? {} : { justifyContent: "center" }}
        >
          {window.innerWidth > 450 && (
            <Swiper
              direction="horizontal"
              modules={[A11y, Autoplay]}
              spaceBetween={0}
              grabCursor={true}
              slidesPerView={1}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              className={Styles.textConatienr}
            >
              {eldersWords.map((item, index) => (
                <SwiperSlide key={index} className={Styles.singleTextContainer}>
                  {/* <img src={quetsBackground} alt="" /> */}
                  <img
                    src={quoteDownIcon}
                    className={Styles.rightQuote}
                    alt=""
                  />
                  <img
                    src={quoteDownIcon}
                    className={Styles.leftQuote}
                    alt=""
                  />
                  <div className={Styles.title}>
                    {item.titleImage && (
                      <img
                        src={
                          reservedImages.find((i) => i.name === item.titleImage)
                            .icon
                        }
                        alt=""
                      />
                    )}
                    <h2>{item.name}</h2>
                  </div>
                  <p>{item.text}</p>
                  <div className={Styles.writer}>
                    <h4>{item.writer}</h4>
                    {item.writerImage && (
                      <img
                        src={
                          reservedImages.find(
                            (i) => i.name === item.writerImage
                          ).icon
                        }
                        alt=""
                      />
                    )}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          <div className={Styles.imagesContainer}>
            <Swiper
              direction="horizontal"
              modules={[
                A11y,
                Autoplay,
                // ,Navigation, Pagination
              ]}
              spaceBetween={0}
              grabCursor={true}
              slidesPerView={1}
              pagination={{
                clickable: true,
              }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              className={Styles.imagesSlider}
            >
              <SwiperSlide className={Styles.singleTextContainer}>
                <a
                  referrerPolicy="origin"
                  target="_blank"
                  href="https://trustseal.enamad.ir/?id=387572&Code=U5lIXYBIjkbrNB7fvZrqKPSqEuXscoY5"
                >
                  <img
                    referrerPolicy="origin"
                    src={enamadImg}
                    alt="اینماد"
                    style={{ cursor: "pointer" }}
                    code="U5lIXYBIjkbrNB7fvZrqKPSqEuXscoY5"
                  />
                </a>
              </SwiperSlide>
              <SwiperSlide className={Styles.singleTextContainer}>
                <a
                  href="https://logo.samandehi.ir/Verify.aspx?id=365813&p=xlaogvkadshwmcsirfthxlao"
                  referrerPolicy="origin"
                  target="_blank"
                  style={{ color: "black" }}
                >
                  <img
                    referrerPolicy="origin"
                    id="rgvjfukzapfuoeukjxlzrgvj"
                    alt="logo-samandehi"
                    // src="https://logo.samandehi.ir/logo.aspx?id=365813&p=qftiwlbqujynaqgwnbpdqfti"
                    src={samandehi}
                  />
                </a>
              </SwiperSlide>
              <SwiperSlide className={Styles.singleTextContainer}>
                <div onClick={() => setShowMojavez(true)}>
                  <img
                    src={parvaneNashrImg}
                    alt="مجوز پروانه نشر دیجیتال"
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default LandingContent;
